export const sinkingFundPayment = (
	interestPerPeriod: number,
	periods: number,
	targetAmount: number,
) => {
	if (periods <= 0 || targetAmount <= 0) {
		return 0;
	}

	if (interestPerPeriod === 0) {
		return Math.round(targetAmount / periods);
	}

	return Math.round(
		(targetAmount * interestPerPeriod) /
			((1 + interestPerPeriod) ** periods - 1),
	);
};
